export default {"src":"/_next/static/media/twitter.9fbe6543.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};